// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var List   = require("bs-platform/lib/js/list.js");
var Option = require("./Option");

function splitAtHelper(index, _originalList, _newList) {
  while(true) {
    var newList = _newList;
    var originalList = _originalList;
    if (originalList) {
      if (List.length(newList) < index) {
        _newList = /* :: */[
          originalList[0],
          newList
        ];
        _originalList = originalList[1];
        continue ;
        
      } else {
        return /* tuple */[
                List.rev(newList),
                originalList
              ];
      }
    } else {
      return /* tuple */[
              List.rev(newList),
              /* [] */0
            ];
    }
  };
}

function insertAt(index, elem, list) {
  var match = splitAtHelper(index, list, /* [] */0);
  return List.concat(/* :: */[
              match[0],
              /* :: */[
                /* :: */[
                  elem,
                  /* [] */0
                ],
                /* :: */[
                  match[1],
                  /* [] */0
                ]
              ]
            ]);
}

var List$1 = /* module */[/* insertAt */insertAt];

function focusElement(element) {
  setTimeout((function () {
          return Option.run((function (elem) {
                        return elem.focus();
                      }), element[0]);
        }), 200);
  return /* () */0;
}

function focusAndHighlightElement(element) {
  setTimeout((function () {
          return Option.run((function (elem) {
                        elem.focus();
                        elem.selectionStart = 0;
                        return elem.selectionEnd = elem.value.length;
                      }), element[0]);
        }), 200);
  return /* () */0;
}

function Dom_002(prim, prim$1) {
  document.addEventListener(prim, prim$1);
  return /* () */0;
}

function Dom_003(prim, prim$1) {
  document.removeEventListener(prim, prim$1);
  return /* () */0;
}

function Dom_004(prim) {
  return prim;
}

var Dom = /* module */[
  /* focusElement */focusElement,
  /* focusAndHighlightElement */focusAndHighlightElement,
  Dom_002,
  Dom_003,
  Dom_004
];

function getMousePositionFromEvent($$event) {
  return /* tuple */[
          $$event.pageX,
          $$event.pageY
        ];
}

function getClickOffsetFromEvent($$event) {
  var nativeEvent = $$event.nativeEvent;
  return /* tuple */[
          nativeEvent.offsetX,
          nativeEvent.offsetY
        ];
}

function getValueFromEvent($$event) {
  return $$event.target.value;
}

function identity(x) {
  return x;
}

exports.List                      = List$1;
exports.Dom                       = Dom;
exports.getMousePositionFromEvent = getMousePositionFromEvent;
exports.getClickOffsetFromEvent   = getClickOffsetFromEvent;
exports.getValueFromEvent         = getValueFromEvent;
exports.identity                  = identity;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./src/Utils.re
// module id = 5
// module chunks = 0